/** Protected-route wrapper voor admin. */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../lib/adminAuth";

export function RequireAdmin({ children }) {
  const { isAuthenticated, bootstrapping, mfaPending } = useAdminAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="admin-bootstrapping">
        <div className="text-sm text-slate-500">Sessie laden…</div>
      </div>
    );
  }
  if (mfaPending) {
    return <Navigate to="/admin/mfa" replace state={{ from: location }} />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
